import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/common/SafeIcon';
import Navbar from '../components/Navbar';

const { FiActivity, FiUsers, FiAlertTriangle, FiCheckCircle, FiLayout, FiPieChart, FiSettings } = FiIcons;

// Bruker 'export const' direkte for å garantere at App.jsx finner navngitt import
export const Dashboard = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <header className="mb-10 flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <h1 className="text-3xl font-black text-slate-900 tracking-tight">HMS Dashbord</h1>
            <p className="text-slate-500 font-medium">Sanntidsoversikt for HMS-innsikt Cloud</p>
          </div>
          <div className="flex gap-3">
            <button className="px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-700 hover:bg-slate-50 transition-all">
              Eksporter rapport
            </button>
            <button className="px-4 py-2 bg-blue-600 rounded-xl text-sm font-bold text-white hover:bg-blue-700 transition-all shadow-lg shadow-blue-100">
              Ny måling
            </button>
          </div>
        </header>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-10">
          {[
            { label: 'Arbeidsmiljø-indeks', value: '78/100', icon: FiActivity, color: 'text-green-600', bg: 'bg-green-100' },
            { label: 'Sykefraværsrisiko', value: 'Lav', icon: FiAlertTriangle, color: 'text-blue-600', bg: 'bg-blue-100' },
            { label: 'Fullføringsgrad', value: '92%', icon: FiCheckCircle, color: 'text-green-600', bg: 'bg-green-100' },
            { label: 'Aktive tiltak', value: '12', icon: FiLayout, color: 'text-orange-600', bg: 'bg-orange-100' },
          ].map((stat, i) => (
            <div key={i} className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm">
              <div className={`w-12 h-12 ${stat.bg} ${stat.color} rounded-2xl flex items-center justify-center mb-4 text-xl`}>
                <SafeIcon icon={stat.icon} />
              </div>
              <p className="text-sm font-bold text-slate-500 mb-1 uppercase tracking-wider">{stat.label}</p>
              <p className="text-3xl font-black text-slate-900">{stat.value}</p>
            </div>
          ))}
        </div>

        {/* Main Content Placeholder */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 bg-white rounded-3xl border border-slate-100 shadow-sm p-8 min-h-[400px]">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2">
              <SafeIcon icon={FiPieChart} className="text-blue-600" />
              Trendanalyse - HMS-innsikt
            </h3>
            <div className="w-full h-64 bg-slate-50 rounded-2xl flex items-center justify-center border-2 border-dashed border-slate-200 text-slate-400 font-medium italic">
              Grafikk for arbeidsmiljøutvikling lastes...
            </div>
          </div>
          
          <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2">
              <SafeIcon icon={FiSettings} className="text-blue-600" />
              Anbefalte tiltak
            </h3>
            <div className="space-y-4">
              {[1, 2, 3].map((_, i) => (
                <div key={i} className="p-4 bg-slate-50 rounded-2xl border border-slate-100">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mb-2" />
                  <p className="font-bold text-slate-900 text-sm">Tiltak #{i+1}</p>
                  <p className="text-xs text-slate-500 mt-1">Automatisert anbefaling fra HMS-innsikt AI.</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Eksporterer i tillegg som default ifall andre komponenter forventer det
export default Dashboard;